"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.types = exports["default"] = exports.dataCyRole = void 0;
var _types = require("./types");
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _excluded = ["value", "type"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var dataCyRole = exports.dataCyRole = 'descriptionValue';
var types = exports.types = {
  link: _types.DescriptionLink,
  text: _types.DescriptionText,
  status: _types.DescriptionStatus,
  metadata: _types.DescriptionMetadata,
  date: _types.DescriptionDate,
  dateRange: _types.DescriptionDateRange,
  amount: _types.DescriptionAmount,
  percent: _types.DescriptionPercent,
  typographyList: _types.DescriptionTypographyList,
  decimal: _types.DescriptionDecimal,
  decimalRange: _types.DescriptionRangeDecimal,
  currencyRange: _types.DescriptionCurrencyRange
};
var DescriptionValue = function DescriptionValue(_ref) {
  var value = _ref.value,
    type = _ref.type,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var typeFactory = (0, _react.useMemo)(function () {
    var _typeFactory = function _typeFactory(_ref2) {
      var value = _ref2.value;
      return value;
    };
    if (type) {
      if ((0, _isFunction["default"])(type) || /*#__PURE__*/(0, _react.isValidElement)(type)) {
        _typeFactory = type;
      } else if ((0, _isString["default"])(type)) {
        _typeFactory = types[type];
      }
    }
    return _typeFactory;
  }, [type]);
  var typeLabel = typeof type === 'string' ? type : 'custom';
  return /*#__PURE__*/(0, _react.createElement)(typeFactory, _objectSpread(_objectSpread({}, otherProps), {}, {
    'data-cy-type': typeLabel,
    'data-cy-role': dataCyRole,
    value: value
  }));
};
DescriptionValue.protoTypes = {
  type: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(Object.keys(types)), _propTypes["default"].func]),
  value: _propTypes["default"].any
};
var _default = exports["default"] = DescriptionValue;